module.exports = __webpack_public_path__ + "img/discord.d778f8f8.svg";